<div class="view-annotate-tools" gaCategory="View Whiteboard Tools">
    <app-pillbox
        eventCategory="View Whiteboard Tools"
        name="Whiteboard"
        padding="dense"
        [canExit]="true"
        (exit)="handleExitClick()">


        <button
            class="mr-1"
            [matMenuTriggerFor]="textSizeMenu"
            app-pin-button
            buttonType="ghost"
            icon="text-size"
            aria-label="Text"
            matTooltip="Text"
            [selected]="(mode$ | async) === modeEnum.Text"
            (click)="handleModeSelect(modeEnum.Text)">
        </button>

        <button
            class="mr-1"
            [matMenuTriggerFor]="brushSizeMenu"
            app-pin-button
            buttonType="ghost"
            icon="paint-brush"
            aria-label="Brush"
            matTooltip="Brush"
            [selected]="(mode$ | async) === modeEnum.Paint"
            (click)="handleModeSelect(modeEnum.Paint)">
        </button>

        <button
            [matMenuTriggerFor]="eraserSizeMenu"
            app-pin-button
            buttonType="ghost"
            icon="eraser"
            aria-label="Eraser"
            matTooltip="Eraser"
            [selected]="(mode$ | async) === modeEnum.Erase"
            [disabled]="!(hasPaint$ | async)"
            (click)="handleModeSelect(modeEnum.Erase)">
        </button>

        <app-pillbox-divider></app-pillbox-divider>


        <button
            #colorBtn
            [matMenuTriggerFor]="brushColorMenu"
            app-pin-button
            buttonType="ghost"
            icon="tint"
            aria-label="Color"
            matTooltip="Color">
        </button>

        <app-pillbox-divider></app-pillbox-divider>

        <button
            app-pin-button
            buttonType="ghost"
            icon="download"
            aria-label="Download"
            matTooltip="Download"
            (click)="handleDownloadClick()">
        </button>

        <app-pillbox-divider></app-pillbox-divider>

        <button
            app-pin-button
            buttonType="ghost"
            aria-label="Clear"
            matTooltip="Clear"
            [disabled]="!(hasPaint$ | async) && !(hasText$ | async)"
            (click)="handleClearClick()">
            Clear
        </button>


        <!-- menu: text size -->
        <mat-menu #textSizeMenu="matMenu">

            <button               
                mat-menu-item
                *ngFor="let size of textSizes"
                (click)="setTextSize(size.size)">

                <div class="flex flex-row items-center justify-end">
                    <div class="view-annotate-tools__check">
                        <app-icon
                            *ngIf="size.size === (textSize$ | async)"
                            class="mr-2"
                            icon="check">
                        </app-icon>
                    </div>

                    <div class="view-annotate-tools__label">
                        <span>{{ size.label }}px</span>
                    </div>
                </div>

            </button>

        </mat-menu>

        <!-- menu: brush size -->
        <mat-menu #brushSizeMenu="matMenu">

            <button               
                mat-menu-item
                *ngFor="let size of brushSizes"
                (click)="setBrushSize(size.size)">

                <div class="flex flex-row items-center justify-end">
                    <div class="view-annotate-tools__check">
                        <app-icon
                            *ngIf="size.size === (brushSize$ | async)"
                            class="mr-2"
                            icon="check">
                        </app-icon>
                    </div>

                    <div class="view-annotate-tools__label">
                        <app-icon
                            class="mr-2"
                            icon="circle"
                            [style.font-size.px]="size.size">
                        </app-icon>
                        
                        <span>{{ size.label }}</span>
                    </div>
                </div>

            </button>

        </mat-menu>

        <!-- menu: eraser size -->
        <mat-menu #eraserSizeMenu="matMenu">

            <button               
                mat-menu-item
                *ngFor="let size of eraserSizes"
                (click)="setEraserSize(size.size)">

                <div class="flex flex-row items-center justify-end">
                    <div class="view-annotate-tools__check">
                        <app-icon
                            *ngIf="size.size === (eraserSize$ | async)"
                            class="mr-2"
                            icon="check">
                        </app-icon>
                    </div>

                    <div class="view-annotate-tools__label">
                        <app-icon
                            class="mr-2"
                            icon="circle"
                            [style.font-size.px]="size.size">
                        </app-icon>
                        
                        <span>{{ size.label }}</span>
                    </div>
                </div>

            </button>

        </mat-menu>

        <!-- menu: brush color -->
        <mat-menu #brushColorMenu="matMenu">

            <button                
                mat-menu-item
                *ngFor="let color of brushColors"
                (click)="setBrushColor(color.color)">

                <div class="flex flex-row items-center justify-end">
                    <div class="view-annotate-tools__check">
                        <app-icon
                            *ngIf="color.color === (brushColor$ | async)"
                            class="mr-2"
                            icon="check">
                        </app-icon>
                    </div>

                    <div class="view-annotate-tools__label">
                        <app-icon
                            class="mr-2"
                            icon="circle"
                            [style.font-size.px]="14"
                            [style.color]="color.color">
                        </app-icon>

                        <span>{{ color.label }}</span>

                    </div>
                </div>

            </button>

        </mat-menu>

    </app-pillbox>
</div>